
/* VELOURÉ LUXE — DESKTOP FILTER DROPDOWN */
/* Mobile retains the original Shopify filter drawer. */

document.addEventListener('DOMContentLoaded', function () {
  const desktop = window.matchMedia('(min-width: 1280px)');

  document.querySelectorAll('.facest-filters-section').forEach(function (section) {
    const button = section.querySelector('.sf__sidebar-open');
    const sidebar = section.querySelector('.sf__sidebar[data-type="fixed"]');
    const content = sidebar?.querySelector('.sf__sidebar-content');

    if (!button || !sidebar || !content) return;

    let isOpen = false;

    function positionDropdown() {
      if (!desktop.matches) return;

      const rect = button.getBoundingClientRect();
      const width = 250;
      const gap = 8;

      const left = Math.max(
        8,
        Math.min(rect.left, window.innerWidth - width - 8)
      );

      sidebar.style.setProperty('--veloure-top', `${rect.bottom + gap}px`);
      sidebar.style.setProperty('--veloure-left', `${left}px`);
    }

    function openDropdown() {
      positionDropdown();

      sidebar.style.display = 'block';
      sidebar.style.setProperty('--tw-bg-opacity', '0');
      content.style.setProperty('--tw-translate-x', '0');
      content.style.setProperty('transform', 'none', 'important');

      section.classList.add('sidebar-open');
      button.setAttribute('aria-expanded', 'true');
      isOpen = true;
    }

    function closeDropdown() {
      sidebar.style.display = 'none';
      section.classList.remove('sidebar-open');
      button.setAttribute('aria-expanded', 'false');
      isOpen = false;
    }

    // Capture desktop clicks before the theme's drawer handler.
    button.addEventListener('click', function (event) {
      if (!desktop.matches) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (isOpen) {
        closeDropdown();
      } else {
        openDropdown();
      }
    }, true);

    // Close when clicking outside the dropdown.
    document.addEventListener('click', function (event) {
      if (!desktop.matches || !isOpen) return;

      if (
        !sidebar.contains(event.target) &&
        !button.contains(event.target)
      ) {
        closeDropdown();
      }
    });

    // Close using the Escape key.
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && desktop.matches && isOpen) {
        closeDropdown();
        button.focus();
      }
    });

    // Keep the menu aligned while scrolling or resizing.
    window.addEventListener('scroll', function () {
      if (isOpen && desktop.matches) positionDropdown();
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (!desktop.matches) {
        isOpen = false;
        button.removeAttribute('aria-expanded');
        sidebar.style.removeProperty('display');
        sidebar.style.removeProperty('--tw-bg-opacity');
        content.style.removeProperty('--tw-translate-x');
        content.style.removeProperty('transform');
        section.classList.remove('sidebar-open');
      } else if (isOpen) {
        positionDropdown();
      }
    });
  });
});
